import axios from '../utils/axios'

export default {
  userInfoUpdate ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post('/recruitment/user/userInfo').then(res => {
        resolve(res.data)
        commit('SAVA_USER_INFO', res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  freeRightUpdate ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
      .post("/recruitment/employ_activity/free_right", {
        state: 1,
      })
      .then((res) => {
        const number = res.data.paging.total;
        // const number = 10;

        resolve(number)
        commit('FREE_RIGHT', number)
      }).catch(err => {
        reject(err)
      });
      
    })
  }
}
